import React from 'react';

import TextInput from 'components/forms/TextInput/TextInput';

const NewCustomerBillingAddressInfoInputs = ({ formik, accountType }) => {
  const isLiveInstance = accountType === 'LIVE_INSTANCE';
  return (
    <div className='row'>
      <div className='col-md-12 mb-3'>
        <TextInput
          name='billingInfo.addressLine1'
          label='Address Line 1'
          value={formik.values.billingInfo?.addressLine1}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isRequired={isLiveInstance}
          error={formik.touched.billingInfo?.addressLine1 && formik.errors.billingInfo?.addressLine1}
        />
      </div>
      <div className='col-md-12 mb-3'>
        <TextInput
          name='billingInfo.addressLine2'
          label='Address Line 2'
          value={formik.values.billingInfo?.addressLine2}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.billingInfo?.addressLine2 && formik.errors.billingInfo?.addressLine2}
        />
      </div>
      <div className='col-md-12 mb-3'>
        <TextInput
          name='billingInfo.addressLine3'
          label='Address Line 3'
          value={formik.values.billingInfo?.addressLine3}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.billingInfo?.addressLine3 && formik.errors.billingInfo?.addressLine3}
        />
      </div>
      <div className='col-md-6 mb-3'>
        <TextInput
          name='billingInfo.state'
          label='State'
          value={formik.values.billingInfo?.state}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.billingInfo?.state && formik.errors.billingInfo?.state}
        />
      </div>
      <div className='col-md-6 mb-3'>
        <TextInput
          name='billingInfo.city'
          label='City'
          value={formik.values.billingInfo?.city}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isRequired={isLiveInstance}
          error={formik.touched.billingInfo?.city && formik.errors.billingInfo?.city}
        />
      </div>
      <div className='col-md-6 mb-3'>
        <TextInput
          name='billingInfo.zip'
          label='Zip Code'
          value={formik.values.billingInfo?.zip}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isRequired={isLiveInstance}
          error={formik.touched.billingInfo?.zip && formik.errors.billingInfo?.zip}
        />
      </div>
      <div className='col-md-6 mb-3'>
        <TextInput
          name='billingInfo.taxRegistrationNumber'
          label='Tax Registration Number'
          value={formik.values.billingInfo?.taxRegistrationNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.billingInfo?.taxRegistrationNumber && formik.errors.billingInfo?.taxRegistrationNumber}
        />
      </div>
    </div>
  );
};

export default NewCustomerBillingAddressInfoInputs;
